var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("@/assets/images/bg-system-update.png")}}),_c('button',{staticClass:"refresh",on:{"click":_vm.canIUse}},[_vm._v("刷新")])])
}
var staticRenderFns = []

export { render, staticRenderFns }